import { type FC } from "react";
import { type DragDropWrapperProps } from "./DragDropTypes";

export const DefaultWrapper: FC<DragDropWrapperProps> = ({ children }) => {
    return (
        <div className="w-[700px] p-2">
            {children}
        </div>
    );
};
